import { render, staticRenderFns } from "./cods.vue?vue&type=template&id=5a534c74&"
import script from "./cods.vue?vue&type=script&lang=js&"
export * from "./cods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports